'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { resolveBenefitMenuGroups } from '../_utils/resolveBenefitMenuGroups';
export const useBenefitMenus = isGuest => {
  const $ = _c(7);
  const pathname = usePathname();
  let t0;
  if ($[0] !== isGuest) {
    t0 = isGuest ? UnauthQueryOptions["get:/wello/v2/allows/benefit-menus"]() : AuthQueryOptions["get:/wello/v2/auth/benefit-menus"]();
    $[0] = isGuest;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname) {
    t1 = data => resolveBenefitMenuGroups(data?.context ?? [], pathname ?? "");
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      ...t0,
      select: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useSuspenseQuery(t2);
};